import React, { useState } from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import StockTable from "./components/StockTable";
import StockModal from "./components/StockModal";
import StockHistoryModal from "./components/StockHistoryModal"; // 🔥 Komponen baru
import StockReport from "./components/StockReport";
import StockExport from "./components/StockExport";
import CategoryFilter from "./components/CategoryFilter";
import Swal from "sweetalert2";

// Dummy data
const dummyCategories = ["Food", "Drink", "Snack"];
const dummyStock = [
  { id: 1, name: "Burger", category: "Food", stock: 50 },
  { id: 2, name: "Coca Cola", category: "Drink", stock: 30 },
  { id: 3, name: "Chips", category: "Snack", stock: 20 },
];

const dummyHistory = [
  {
    id: 1,
    productId: 1,
    product: "Burger",
    change: -5,
    date: "2024-02-20 10:30 AM",
  },
  {
    id: 2,
    productId: 1,
    product: "Burger",
    change: +10,
    date: "2024-02-22 02:15 PM",
  },
  {
    id: 3,
    productId: 2,
    product: "Coca Cola",
    change: -3,
    date: "2024-02-21 01:00 PM",
  },
];

const POS_Stock = () => {
  const [stockList, setStockList] = useState(dummyStock);
  const { handleSuccess } = useCanvasHandler();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showStockModal, setShowStockModal] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false); // 🔥 State baru untuk modal history
  const [adjustment, setAdjustment] = useState(0);
  const [history, setHistory] = useState(dummyHistory);
  const [filterCategory, setFilterCategory] = useState("All");

  // 🔥 Function untuk menampilkan history produk yang diklik
  const handleShowHistory = (product) => {
    setSelectedProduct(product);
    setShowHistoryModal(true);
  };

  // 🔥 Handle stock update
  const handleStockUpdate = () => {
    if (!selectedProduct || adjustment === 0) return;

    Swal.fire({
      title: "Are you sure?",
      text: `You are about to ${adjustment > 0 ? "add" : "reduce"} ${Math.abs(
        adjustment
      )} stock for ${selectedProduct.name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedStockList = stockList.map((item) =>
          item.id === selectedProduct.id
            ? { ...item, stock: item.stock + adjustment }
            : item
        );

        setStockList(updatedStockList);

        // 🔥 Tambahkan ke history perubahan stok
        setHistory([
          ...history,
          {
            id: history.length + 1,
            product: selectedProduct.name,
            change: adjustment,
            date: new Date().toLocaleString(),
          },
        ]);

        handleSuccess(`Stock updated successfully!`);
        setShowStockModal(false);
        setAdjustment(0);
      }
    });
  };

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-5">
        <div className="d-flex justify-content-between mb-3">
          <CategoryFilter
            categories={dummyCategories}
            filterCategory={filterCategory}
            setFilterCategory={setFilterCategory}
          />
          <StockExport stockList={stockList} history={history} />
        </div>

        <div className="card mb-3">
          <StockTable
            stockList={stockList}
            setSelectedProduct={setSelectedProduct}
            setShowStockModal={setShowStockModal}
            setAdjustment={setAdjustment}
            onShowHistory={handleShowHistory} // 🔥 Tambahkan event klik
          />
        </div>
        <StockReport history={history} />

        <StockModal
          show={showStockModal}
          onHide={() => setShowStockModal(false)}
          // onSave={() => {}}
          onSave={handleStockUpdate} // 🔥 Ganti dengan fungsi handleStockUpdate
          product={selectedProduct}
          adjustment={adjustment}
          setAdjustment={setAdjustment}
        />
        <StockHistoryModal // 🔥 Tampilkan modal history
          show={showHistoryModal}
          onHide={() => setShowHistoryModal(false)}
          product={selectedProduct}
          history={history}
        />
      </div>
    </LayoutDashboard>
  );
};

export default POS_Stock;
